import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	approvalsDescription: {
		id: 'horizontal-nav-add-tab-details.approvals-description',
		defaultMessage: 'Add approvals into your workflow to save you time following up.',
		description: 'Description of the approvals view.',
	},
	attachmentsDescription: {
		id: 'horizontal-nav-add-tab-details.attachments-description',
		defaultMessage: 'View attachments that have been added to issues within your project.',
		description: 'Description of the attachments view.',
	},
	archivedIssuesDescription: {
		id: 'horizontal-nav-add-tab-details.archived-issues-description',
		defaultMessage: 'View all the issues archived in your project here.',
		description: 'Description of the archived issues view.',
	},
	attachmentsDescriptionIssueTermRefresh: {
		id: 'horizontal-nav-add-tab-details.attachments-description-issue-term-refresh',
		defaultMessage: 'View attachments that have been added to work items within your project.',
		description: 'Description of the attachments view.',
	},
	archivedIssuesDescriptionIssueTermRefresh: {
		id: 'horizontal-nav-add-tab-details.archived-issues-description-issue-term-refresh',
		defaultMessage: 'View all the work items archived in your project here.',
		description: 'Description of the archived issues view.',
	},
	issuesDescription: {
		id: 'horizontal-nav-add-tab-details.issues-description',
		defaultMessage:
			'View all the issues in your project. Use built-in filters and text search to find issues.',
		description: 'Description of the issues view.',
	},
	backlogDescription: {
		id: 'horizontal-nav-add-tab-details.backlog-description',
		defaultMessage: "Plan and prioritize your team's work in a dedicated space.",
		description: 'Description of the backlog view.',
	},
	reportsDescription: {
		id: 'horizontal-nav-add-tab-details.reports-description',
		defaultMessage: 'View statistics for people, projects, versions, or information about issues.',
		description: 'Description of the reports view.',
	},
	securityDescription: {
		id: 'horizontal-nav-add-tab-details.security-description',
		defaultMessage: 'Connect security tools to triage and track vulnerabilities in Jira.',
		description: 'Description of the security view.',
	},
	boardDescription: {
		id: 'horizontal-nav-add-tab-details.board-description',
		defaultMessage:
			"Get a snapshot of the status of your team's work and easily drag your cards through a workflow.",
		description: 'Description of the board view.',
	},
	codeDescription: {
		id: 'horizontal-nav-add-tab-details.code-description',
		defaultMessage:
			"Connect Bitbucket, GitHub and other development tools to link your team's repositories to Jira.",
		description: 'Description of the code view.',
	},
	componentsDescription: {
		id: 'horizontal-nav-add-tab-details.components-description',
		defaultMessage: 'Use components to create subsections of a project.',
		description: 'Description of the components view.',
	},
	deploymentsDescription: {
		id: 'horizontal-nav-add-tab-details.deployments-description',
		defaultMessage:
			'Easily manage and track deployments for a seamless software delivery experience.',
		description: 'Description of the deployments view.',
	},
	developmentDescription: {
		id: 'horizontal-nav-add-tab-details.development-description',
		defaultMessage:
			'Discover key technical insights and work suggestions for your software development journey in one place.',
		description: 'Description of the development view.',
	},
	goalsDescription: {
		id: 'horizontal-nav-add-tab-details.goals-description',
		defaultMessage: 'View issues that are linked to goals in this project.',
		description: 'Description of the goals view.',
	},
	incidentsDescription: {
		id: 'horizontal-nav-add-tab-details.incidents-description',
		defaultMessage:
			'Triage incidents and track PIR actions in your project by connecting incident management tools.',
		description: 'Description of the incidents view.',
	},
	releasesDescription: {
		id: 'horizontal-nav-add-tab-details.releases-description',
		defaultMessage: 'Versions help you package and schedule project deliveries.',
		description: 'Description of the releases view.',
	},
	requestsDescription: {
		id: 'horizontal-nav-add-tab-details.requests-description',
		defaultMessage: 'Manage, prioritize, and track requests, and connect them to this project.',
		description: 'Description of the requests view.',
	},
	timelineDescription: {
		id: 'horizontal-nav-add-tab-details.timeline-description',
		defaultMessage:
			'Plan and manage your project dependencies on a timeline and see when things are landing.',
		description: 'Description of the timeline view.',
	},
	onCallDescription: {
		id: 'horizontal-nav-add-tab-details.on-call-description',
		defaultMessage: 'View on-call schedules in your project. Requires Opsgenie by Atlassian.',
		description: 'Description of the on-call view.',
	},
	calendarDescription: {
		id: 'horizontal-nav-add-tab-details.calendar-description',
		defaultMessage:
			'See when work is due and get a quick glance at what the next month looks like.',
		description: 'Description of the calendar view.',
	},
	shortcutsDescription: {
		id: 'horizontal-nav-add-tab-details.shortcuts-description',
		defaultMessage: 'Add easily accessible links for your team to access from your project.',
		description: 'Description of the shortcuts view.',
	},
	pagesDescription: {
		id: 'horizontal-nav-add-tab-details.pages-description',
		defaultMessage: 'Create and manage Confluence pages in your project.',
		description: 'Description of the pages view.',
	},
	listDescription: {
		id: 'horizontal-nav-add-tab-details.list-description',
		defaultMessage: "Get a list of your project's work in spreadsheet-like table.",
		description: 'Description of the list view.',
	},
	appDescription: {
		id: 'horizontal-nav-add-tab-details.app-description',
		defaultMessage: 'Supercharge your project by integrating third-party apps.',
		description: 'Description of the app view.',
	},
	formsDescription: {
		id: 'horizontal-nav-add-tab-details.forms-description',
		defaultMessage: 'Collect information for your team with forms.',
		description: 'Description of the forms view.',
	},
	summaryDescriptionNonFinal: {
		id: 'horizontal-nav-add-tab-details.summary-description-non-final',
		defaultMessage:
			'Get an overview of work progress, priorities, workload distribution, and other projects.',
		description: 'Description of the summary page view.',
	},
	issuesDescriptionIssueTermRefresh: {
		id: 'horizontal-nav-add-tab-details.issues-description-issue-term-refresh',
		defaultMessage:
			'View all the work items in your project. Use built-in filters and text search to find work items.',
		description: 'Description of the issues view.',
	},
	reportsDescriptionIssueTermRefresh: {
		id: 'horizontal-nav-add-tab-details.reports-description-issue-term-refresh',
		defaultMessage:
			'View statistics for people, projects, versions, or information about work items.',
		description: 'Description of the reports view.',
	},
	goalsDescriptionIssueTermRefresh: {
		id: 'horizontal-nav-add-tab-details.goals-description-issue-term-refresh',
		defaultMessage: 'View work items that are linked to goals in this project.',
		description: 'Description of the goals view.',
	},
	inboxDescription: {
		id: 'horizontal-nav.inbox-description',
		defaultMessage:
			'Enable customer service teams to forward work items to this project. Teams will see this project in their forwarding options and can forward work directly to your inbox.',
		description: 'Description of the forwarded work items inbox view.',
	},
});
